// UserHome.js
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import MainHeader from "./MainHeader";
import MainBody from "./MainBody";
import EntityNotification from "./EntityNotification";
import { SuccessModal } from "src/components/common/modal";
import { useAppSelector } from "src/redux/store";
import { isAccessLocked, ACCESS_UNLOCK_LABEL } from "src/utils/accessLock";

const UserHome = () => {
  const data = useAppSelector((state) => state.root.user.data);

  // Accounts locked by our access gate (non-PSU entities before the deadline)
  // land here after login; show the info popup over the locked home page.
  const locked = isAccessLocked({
    isGCAEntity: data?.isGCAEntity,
    gcaType: data?.gcaType,
  });

  const [showLockedModal, setShowLockedModal] = useState<boolean>(false);

  useEffect(() => {
    if (locked) setShowLockedModal(true);
  }, [locked]);

  return (
    <>
      <MainHeader />
      <MainBody />
      <EntityNotification />

      <SuccessModal
        open={showLockedModal}
        type="unSuccess"
        isAlert
        heading="Access Not Yet Available"
        btnText="OK"
        closeOnBackDrop
        handleModalClose={() => setShowLockedModal(false)}
        onClick={() => setShowLockedModal(false)}
      >
        <Box sx={{ textAlign: "center", lineHeight: 1.7, color: "#444" }}>
          This is to inform you that you can access your Green Credit Programme
          (GCP) account from
          <Box
            component="div"
            sx={{ fontWeight: 700, color: "#0D9488", my: 1.5 }}
          >
            {ACCESS_UNLOCK_LABEL} (IST)
          </Box>
          Please log in again after this time to continue. We appreciate your
          cooperation.
        </Box>
      </SuccessModal>
    </>
  );
};

export default UserHome;

//new

// UserHome.js
// import MainHeader from "./MainHeader";
// import MainBody from "./MainBody";
// import EntityNotification from "./EntityNotification";

// const UserHome = () => {
//   return (
//     <>
//       <h1>hy</h1>
//     </>
//   );
// };

// export default UserHome;
